module.exports = __webpack_public_path__ + "static/media/kids_41.fac98aca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_41.jpg
// module id = 5897
// module chunks = 0